<template>
  <component :is="layout">
    <router-view :key="$route.fullPath" />
  </component>
</template>
<script>
/* eslint-disable */

import { defineAsyncComponent } from "vue";
import { getToken } from "firebase/app-check";

const Horizontal = defineAsyncComponent(
  () => import("@/views/Layouts/Horizontal.vue"),
);
// import Full from "@/views/Layouts/Full.vue";
// import Horizontal from "@/views/Layouts/Horizontal.vue";
import { logEvent } from "firebase/analytics";

const Full = defineAsyncComponent(() => import("@/views/Layouts/Full.vue"));

export default {
  name: "App",
  components: {
    Full,
    Horizontal,
  },
  data() {
    return { appCheckRefreshInterval: null };
  },
  methods: {
    async refreshAppCheckToken() {
      try {
        const tokenResult = await getToken(this.$appCheck, true); // force refresh
        const token = tokenResult.token;

        // ✅ Dispatch Vuex action instead of committing directly
        this.$store.dispatch("updateTokenAuth", token);

        console.log("App Check token refreshed & stored:", token);
      } catch (err) {
        console.error("Failed to refresh App Check token", err);
      }
    },
  },
  computed: {
    layout() {
      if (
        this.$route.meta.layout === "full" ||
        this.$route.meta.layout === undefined
      ) {
        return "full";
      } else {
        return `horizontal`;
      }
    },
  },
  beforeMount() {
    //this.$store.state.isTransparent = "bg-transparent";
  },
  mounted() {
    document.body.classList.remove("dark-version");

    if (this.$analytics) {
      logEvent(this.$analytics, "page_view", {
        page_path: window.location.pathname, // The current page path
        page_title: document.title, // The current page title
      });
    } else {
      console.log("Analytics not available!");
    }

    // 🔄 Start token refresh loop
    this.refreshAppCheckToken();
    this.appCheckRefreshInterval = setInterval(
      () => {
        this.refreshAppCheckToken();
      },
      20 * 60 * 1000,
    ); // 12 minutes
  },
  beforeUnmount() {
    // 🔁 Clear interval on component unmount (SSR/SPA navigation)
    if (this.appCheckRefreshInterval) {
      clearInterval(this.appCheckRefreshInterval);
    }
  },
};
</script>
<style scoped></style>
